<template>
  <div>
    <transition name="fade">
      <alert type="error" :message="error" v-if="error" />
    </transition>
    <div class="slds-grid rules-container" v-if="localValue">
      <card :additional-classes="'slds-card_boundary' + (standardRules ? ' standard-rules-container' : '')" class="filters-card" :title="`${localValue.segmentName} (${localValue.operator})`">
        <template #actions v-if="editable">
          <ul class="slds-button-group-list">
            <li>
              <button class="slds-button slds-button_neutral" :disabled="!canAddRule" @click="addRule">
                <svg class="slds-button__icon slds-button__icon_left" aria-hidden="true">
                  <use xlink:href="../../../../assets/symbols.svg#add"></use>
                </svg>
                {{$t('campaignDesigner.targetDefinition.addRule')}}
              </button>
            </li>
            <li>
              <button class="slds-button slds-button_neutral" :disabled="!canAddRule" @click="showModal('add')">
                <svg class="slds-button__icon slds-button__icon_left" aria-hidden="true">
                  <use xlink:href="../../../../assets/symbols.svg#add"></use>
                </svg>
                {{$t('campaignDesigner.targetDefinition.addRuleGroup')}}
              </button>
            </li>
            <li>
              <button class="slds-button slds-button_neutral" @click="showModal('edit')">
                <svg class="slds-button__icon slds-button__icon_left" aria-hidden="true">
                  <use xlink:href="../../../../assets/symbols.svg#edit"></use>
                </svg>
                {{$t('action.edit')}}
              </button>
            </li>
            <li>
              <button class="slds-button slds-button_neutral" @click="showSaveBookmarkModal = true">
                <svg class="slds-button__icon slds-button__icon_left" aria-hidden="true">
                  <use xlink:href="../../../../assets/symbols.svg#save"></use>
                </svg>
                {{$t('campaignDesigner.targetDefinition.saveGroupAs')}}
              </button>
            </li>
            <li>
              <button class="slds-button slds-button_destructive" @click="$emit('delete', { index })">
                <svg class="slds-button__icon slds-button__icon_left" aria-hidden="true">
                  <use xlink:href="../../../../assets/symbols.svg#delete"></use>
                </svg>
                {{$t('action.delete')}}
              </button>
            </li>
          </ul>
        </template>
        <draggable @start="dragStart" @end="dragEnd" v-model="localValue.conditions" :move="canMove" group="rules">
          <transition-group name="slide-fade-down">
            <template v-for="(condition, index) in localValue.conditions">
              <card :key="index" v-if="localValue.conditions[index] && localValue.conditions[index].type === 'placeholder'">
                <span>Drop here to add</span>
              </card>
              <group-item
                class="slds-p-bottom--x-small"
                :brands="brands"
                :config="config"
                :editable="editable"
                :exclude="localValue.operator === 'NOT'"
                :group-operator="index !== localValue.conditions.length - 1 ? localValue.operator : ''"
                :index="index"
                :key="index"
                :ref="`element_${index}`"
                :scope="scope"
                v-model="localValue.conditions[index]"
                v-else-if="localValue.conditions[index] && localValue.conditions[index].type === 'rule'"
                @delete="handleDeleteRule" />
              <template v-else>
                <group :scope="scope" :brands="brands" class="slds-p-bottom--x-small" :index="index" :ref="`element_${index}`" :key="index" v-model="localValue.conditions[index]" :editable="editable" @delete="handleDeleteGroup" :config="config" />
                <!-- <div :key="`separator_${index}`" class="separator slds-p-vertical--x-small" v-if="index !== localValue.conditions.length - 1">{{localValue.operator}}</div> -->
              </template>
            </template>
          </transition-group>
        </draggable>
      </card>
    </div>

    <transition name="fade">
      <new-group-modal
        @newFromBookmark="createFromBookmark"
        @newGroup="createGroup"
        @editGroup="editGroup"
        @close="closeModal"
        :config="config"
        :group="groupToEdit"
        :modal-action="modalAction"
        v-if="showAddGroupModal" />
    </transition>
    <transition name="fade">
      <save-bookmark-modal-from-group
        @bookmark-added="onBookmarkAdded"
        @close="showSaveBookmarkModal = false"
        :bookmark="localValue"
        :scope="scope"
        v-if="showSaveBookmarkModal" />
    </transition>
  </div>
</template>
<script>
import _ from 'lodash'
import EventBus from '../../../utils/EventBus'
import { validate } from '../../../utils/utils'
import Alert from '../../../slds/Alert'
import Card from '../../../slds/Card'
import Draggable from 'vuedraggable'
import Group from './Group'
import GroupItem from './GroupItem'
import SaveBookmarkModal from './SaveBookmarkModal'
export default {
  name: 'Group',
  components: {
    Alert,
    Card,
    Draggable,
    Group,
    GroupItem,
    NewGroupModal: () => import('./NewGroupModal'),
    SaveBookmarkModalFromGroup: SaveBookmarkModal
  },
  props: {
    brands: Array,
    config: Object,
    editable: Boolean,
    index: Number,
    scope: String,
    standardRules: Boolean,
    value: Object
  },
  data () {
    return {
      dragging: false,
      groupToEdit: {},
      error: '',
      oldOperator: '',
      localValue: {},
      modalAction: '',
      newGroup: {
        operator: '',
        segmentName: ''
      },
      operators: [
        {
          label: this.$t('operators.AND'),
          value: 'AND'
        },
        {
          label: this.$t('operators.OR'),
          value: 'OR'
        },
        {
          label: this.$t('operators.NOT'),
          value: 'NOT'
        }
      ],
      showAddGroupModal: false,
      showSaveBookmarkModal: false
    }
  },
  created () {
    this.localValue = _.cloneDeep(this.value)
    EventBus.$on('start-drag', e => {
      if (e.source === 'group' || e.source === 'bookmark') {
        this.dragging = true
      }
    })

    EventBus.$on('end-drag', e => {
      if (e.source === 'group' || e.source === 'bookmark') {
        this.dragging = false
      }
    })
  },
  methods: {
    dragStart () {
      EventBus.$emit('start-drag', { source: 'group' })
    },
    dragEnd () {
      EventBus.$emit('end-drag', { source: 'group' })
    },
    onBookmarkAdded () {
      EventBus.$emit('bookmark-added')
    },
    canMove () {
      return this.editable && !this.showSaveBookmarkModal
    },
    createFromBookmark (bookmark) {
      this.localValue.conditions.push({
        ...bookmark,
        groupId: this.localValue.id
      })
    },
    createGroup (event) {
      const { segmentName, operator } = event
      const valid = validate(this, 'newGroup_', true)
      if (valid) {
        this.localValue.conditions.push(
          {
            conditions: [],
            operator,
            segmentName,
            type: 'group'
          }
        )

        this.closeModal()
      }
    },
    editGroup (event) {
      const { segmentName, operator } = event
      this.localValue.operator = operator
      this.localValue.segmentName = segmentName
    },
    addRule () {
      this.localValue.conditions.push(
        {
          field: '',
          operator: '',
          table: '',
          type: 'rule',
          values: ''
        }
      )
    },
    closeModal () {
      this.showAddGroupModal = false
      this.newGroup = {
        operator: '',
        segmentName: ''
      }
    },
    doUpdate () {
      this.$emit('input', this.localValue)
    },
    handleDeleteGroup (event) {
      this.localValue.conditions = this.localValue.conditions.filter((element, index) => index !== event.index)
    },
    handleDeleteRule (event) {
      this.localValue.conditions = this.localValue.conditions.filter((element, index) => index !== event.index)
    },
    showModal (action) {
      this.modalAction = action
      if (action === 'edit') {
        this.groupToEdit = {
          operator: this.localValue.operator,
          segmentName: this.localValue.segmentName
        }
      }
      this.showAddGroupModal = true
    },
    update: _.debounce((self) => self.doUpdate(self.localValue), 100),
    validate () {
      let error = ''
      let valid = true

      if (!this.localValue.operator) {
        error = this.$t('campaignDesigner.targetDefinition.validation.missingOperator')
        valid = false
      } else {
        if (this.localValue.operator === 'NOT' && this.localValue.conditions.length !== 1) {
          error = this.$t('campaignDesigner.targetDefinition.validation.oneConditionRequired')
          valid = false
        } else if ((this.localValue.operator === 'AND' || this.localValue.operator === 'OR') && (this.localValue.conditions.length < 2)) {
          error = this.$t('campaignDesigner.targetDefinition.validation.twoOrMoreConditionsRequired')
          valid = false
        }
      }

      if (valid) {
        const refs = Object.entries(this.$refs)
          .filter(([k, v]) => k.startsWith('element_'))
          .map(([k, v]) => v)
          .flat()

        valid = refs
          .map(r => r.validate())
          .every(v => !!v)

        if (!valid) {
          error = this.$t('validation.invalidDataMessage')
        }
      }

      this.error = error
      return valid
    }
  },
  computed: {
    nbsp () {
      return '\xa0'
    },
    canAddRule () {
      if (this.localValue.operator === 'NOT') {
        return this.localValue.conditions.length === 0
      } else {
        return true
      }
    }
  },
  watch: {
    dragging (to, from) {
      if (!from && to) {
        if (this.localValue && this.localValue.conditions && !this.localValue.conditions.length) {
          this.localValue.conditions.push({ type: 'placeholder' })
        }
      } else if (from && !to) {
        this.localValue.conditions = this.localValue.conditions.filter(c => c.type !== 'placeholder')
      }
    },
    localValue: {
      handler (old, newValue) {
        this.error = ''
        if (newValue.operator !== this.oldOperator) {
          this.oldOperator = newValue.operator

          if (newValue.operator === 'NOT') {
            this.localValue.conditions.splice(1)
          }
        }
        this.update(this)
      },
      deep: true
    },
    value: {
      handler (value) {
        if (JSON.stringify(value) !== JSON.stringify(this.localValue)) { this.localValue = _.cloneDeep(value) }
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
  .row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
  }

  .operator-card {
    margin-top: 0;
    background-color: #F3F2F2;
    flex-grow: 1;
    vertical-align: middle;
    text-align: center;
  }

  .filters-card {
    margin-top: 0;
    flex-grow: 25;
  }

  .full-height {
    height: 100%;
    overflow-y: auto;
  }

  .standard-rules-container {
    background-color: #DDDBDA;
  }

  .separator {
    display: flex;
    align-items: center;
    text-align: center;

    &::before,
    &::after  {
      content: '';
      flex: 1;
      border-bottom: 1px solid #DDDBDA;
    }

    &:empty {
      margin-left: 0em;
      margin-right: 0em;
    }

    &:not(:empty){
      &::before {
        margin-right: 2em;
      }

      &::after {
        margin-left: 2em;
      }
    }
  }

  .and {
    &.cls-1 {
      fill: #fff;
      stroke: #dddbda;
    }

    &.cls-1,
    &.cls-2 {
      stroke-miterlimit: 10;
      stroke-width: 1.5px;
    }

    &.cls-2 {
      fill: #4589ee;
      stroke: #4589ee;
    }

    &.cls-3 {
      fill: #a9ddf3;
    }

    &.cls-4 {
      font-size: 19px;
      fill: #c1c1c1;
      font-family: 'Salesforce Sans';
    }

  }

  .not {
    &.cls-1 {
      fill: #4589ee;
    }

    &.cls-1,
    &.cls-2 {
      stroke: #dddbda;
      stroke-miterlimit: 10;
      stroke-width: 1.5px;
    }

    &.cls-2 {
      fill: #fff;
    }

    &.cls-3 {
      font-size: 19px;
      fill: #c1c1c1;
      font-family: 'Salesforce Sans';
    }

  }

  .or {
    &.cls-1 {
      fill: #fff;
    }

    &.cls-1,
    &.cls-4 {
      stroke: #dddbda;
    }

    &.cls-1,
    &.cls-2,
    &.cls-4 {
      stroke-miterlimit: 10;
      stroke-width: 1.5px;
    }

    &.cls-2,
    &.cls-3,
    &.cls-4 {
      fill: #4589ee;
    }

    &.cls-2 {
      stroke: #4589ee;
    }
    &.cls-5 {
      font-size: 19px;
      fill: #c1c1c1;
      font-family: 'Salesforce Sans';
    }
  }
</style>
